// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalBody {
    background: #252525;
    padding: 20px 30px;
    border-radius: 20px;
}
.modalBody h1 {
    color: white;
    width: 100%;
    font-weight: 600;
    text-align: left;
}

.modalBody h5{
    color: white;
    width: 100%;
    margin-bottom: 5px;
}
.modal-content {
    border-radius: 40px;
    top: 65px;
}

.imgContainer {
    text-align: center;
    width: 100%;
    margin-bottom: 15px;
}
.imgContainer img {
    width: 85%;
    margin: 0px auto;
    text-align: center;
}
.buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 20px
}

.buttonModal {
    background: var(--color1Ink);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 125px;
    height: 45px;
    color: white;
    font-size: 1.3rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-radius: 25px;
    border: none;
    padding: 15px;
}
.buttonModalNeg {
    background: white;
    color: var(--color1Ink);
    border: 3px solid var(--color1Ink);
}

@media (max-width:794px) {
    .list-schedulings-modal{
        min-height: calc(90vh - 224px) !important;
        max-height: calc(90vh - 224px) !important;

    }
}
@media (max-width:576px) {
    .list-schedulings-modal{
        min-height: calc(90vh - 224px) !important;
        max-height: calc(90vh - 224px) !important;

    }
    .modal-top-table{
        display: none;
    }
    .modal-content {
        border-radius: 30px !important;
    }
    .text-value-sm{
        font-size: 12px !important;
    }
}

.modalpayment{
    --bs-modal-width: 90%;
}

.modalpaymentcontent{
    overflow: hidden;
    top: 0px !important;
    height: 80vh;
    background: #252525;
}
.text-value{
    font-size: 24px;
    color: white;
    font-weight: 600;
}
.buttonModal-sm{
    font-size: 15px;
    max-width: 95px;
}

.card-list-button{
    background: #252525;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ModalSchedulings/ModalSchedlings.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI;QACI,yCAAyC;QACzC,yCAAyC;;IAE7C;AACJ;AACA;IACI;QACI,yCAAyC;QACzC,yCAAyC;;IAE7C;IACA;QACI,aAAa;IACjB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".modalBody {\n    background: #252525;\n    padding: 20px 30px;\n    border-radius: 20px;\n}\n.modalBody h1 {\n    color: white;\n    width: 100%;\n    font-weight: 600;\n    text-align: left;\n}\n\n.modalBody h5{\n    color: white;\n    width: 100%;\n    margin-bottom: 5px;\n}\n.modal-content {\n    border-radius: 40px;\n    top: 65px;\n}\n\n.imgContainer {\n    text-align: center;\n    width: 100%;\n    margin-bottom: 15px;\n}\n.imgContainer img {\n    width: 85%;\n    margin: 0px auto;\n    text-align: center;\n}\n.buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    margin-top: 20px\n}\n\n.buttonModal {\n    background: var(--color1Ink);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 125px;\n    height: 45px;\n    color: white;\n    font-size: 1.3rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    border-radius: 25px;\n    border: none;\n    padding: 15px;\n}\n.buttonModalNeg {\n    background: white;\n    color: var(--color1Ink);\n    border: 3px solid var(--color1Ink);\n}\n\n@media (max-width:794px) {\n    .list-schedulings-modal{\n        min-height: calc(90vh - 224px) !important;\n        max-height: calc(90vh - 224px) !important;\n\n    }\n}\n@media (max-width:576px) {\n    .list-schedulings-modal{\n        min-height: calc(90vh - 224px) !important;\n        max-height: calc(90vh - 224px) !important;\n\n    }\n    .modal-top-table{\n        display: none;\n    }\n    .modal-content {\n        border-radius: 30px !important;\n    }\n    .text-value-sm{\n        font-size: 12px !important;\n    }\n}\n\n.modalpayment{\n    --bs-modal-width: 90%;\n}\n\n.modalpaymentcontent{\n    overflow: hidden;\n    top: 0px !important;\n    height: 80vh;\n    background: #252525;\n}\n.text-value{\n    font-size: 24px;\n    color: white;\n    font-weight: 600;\n}\n.buttonModal-sm{\n    font-size: 15px;\n    max-width: 95px;\n}\n\n.card-list-button{\n    background: #252525;\n    width: 30px;\n    height: 30px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
